<template>
  <el-dialog :append-to-body="true" title="创建品牌形象" :visible.sync="showAddModal" width="500px">
    <el-form ref="add-brand-form" :rules="brandFormRules" :model="brandForm" label-width="80px">
      <el-form-item label="头像" prop="url">
        <el-upload class="avatar-uploader" action="#" ref="upload" :show-file-list="false" :before-upload="beforeAvatarUpload">
          <img v-if="brandForm.url" :src="brandForm.url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p style="font-size: 12px">格式支持 PNG/JPG 宽高比为1:1 尺寸不超过512px 大小不超过50KB</p>
      </el-form-item>
      <el-form-item label="品牌名称" prop="brand_name">
        <el-input v-model="brandForm.brand_name" placeholder="1-12个字符，中文占2个字符"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onModalClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onUploadSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addBrands } from '@/api/tencent.local.model'
export default {
  props: ['value', 'accountId'],
  data() {
    return {
      submitLoading: false,
      profileBinary: null,

      brandForm: {
        brand_name: '',
        url: ''
      },
      brandFormRules: {
        brand_name: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }],
        url: [{ required: true, message: '请上传品牌形象', trigger: 'change' }]
      }
    }
  },
  computed: {
    showAddModal: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    onUploadSubmit() {
      this.$refs['add-brand-form'].validate((valid) => {
        if (valid) {
          const { brand_name } = this.brandForm
          this.submitLoading = true
          addBrands({
            ad_account_id: this.accountId,
            name: brand_name,
            file: this.profileBinary
          })
            .then((data) => {
              if (data) {
                this.$emit('add-confirm')
              }
              this.submitLoading = this.showAddModal = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onModalClose() {
      this.showAddModal = false
      this.$refs['add-brand-form'].clearValidate()
    },
    beforeAvatarUpload(file) {
      const isValidType = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
      // 不能大于300kb
      const isValidSize = file.size < 1024 * 50

      if (!isValidType) {
        return this.$message.error('上传头像图片只能是JPG、PNG格式')
      }
      if (!isValidSize) {
        return this.$message.error('上传头像图片大小不能超过50KB')
      }

      this.profileBinary = file
      this.brandForm.url = URL.createObjectURL(file)

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #c7c7c7;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 98px;
    height: 98px;
    display: block;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 98px;
    height: 98px;
    line-height: 98px;
    text-align: center;
  }
}
</style>
